<template>
    <div class="page-guichet page-guichet--ticket">
        <SidebarVue />
        <div class="content">
            <StatusBar :showQuota="true" />
            <div class="content_inner">

                <div class="content_inner_inner" v-if="ticketTypeStore.ticketsPerCategory">
                    <div v-if="cartStore.isQuotaReached" class="quota-banner">
                        {{ $t('quotaPerOrder.reached', { quota: cartStore.quotaPerOrderEffective }) }}
                    </div>

                    <TicketTypeCategoryVue v-for="(category, indexCat) in ticketTypeStore.ticketsPerCategory" :hasTickets="category.tickets.length > 0" :key="indexCat" :category="category.category">
                        <template v-if="category.tickets.length">
                            <TicketTypeVue
                                v-for="(ticketType, indexTt) in category.tickets"
                                :key="indexTt"
                                :ticketType="ticketType"
                                :category="category.category"
                            />
                        </template>
                    </TicketTypeCategoryVue>

                    <div class="bottom-actions">
                        <Button variant="secondary" icon="hand" size="small" :full-width="false" v-if="eventStore.isRoomPlacement" @click="switchToManual()">
                            Placement manuel
                        </Button>
                    </div>
                </div>
                <Cart />
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import Button from '@/components/atoms/Button.vue'
    import { useTicketTypeStore } from '@/stores/TicketTypeStore'
    import TicketTypeVue from '@/components/molecules/CardTicketType.vue'
    import TicketTypeCategoryVue from '@/components/molecules/TicketTypeCategory.vue'
    import SidebarVue from '@/components/organisms/Sidebar.vue'
    import StatusBar from '@/components/organisms/StatusBar.vue'
    import Cart from '@/components/organisms/Cart.vue'
    import { onMounted } from 'vue'
    import { useCartStore } from '@/stores/CartStore'
    import { useEventStore } from '@/stores/EventStore'
    import { useUserStore } from '@/stores/UserStore'
    import { useRouter } from 'vue-router'

    const ticketTypeStore = useTicketTypeStore()
    const cartStore = useCartStore()
    const eventStore = useEventStore()
    const userStore = useUserStore()
    const router = useRouter()

    onMounted(async () => {
        await cartStore.cancel()
        cartStore.isProduct = false
        const eventId = userStore.sellingSession?.eventId._id
        await eventStore.retrieveEvent(eventId)
        await ticketTypeStore.fetchAll()
    })

    const switchToManual = (async () => {
        await cartStore.cancel()
        router.push({name: 'ticket_seats', params: { eventId: eventStore.currentEvent?._id }})
    })

</script>